import { Grid } from '@material-ui/core';
import ReportGijgoGrid from '../ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';
import { useContext, useMemo, useState } from 'react';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import { EditVehicleInspection } from '../VehicleDailyChecks/editVehicleDailyCheck';
import AppContext from '../../../App/AppContext';
import { useHistory } from 'react-router-dom';
import AddVehicleInspection from '../VehicleDailyChecks/vehicleDailyChecks';

const VehicleInspectionGrid = (props) => {
    const [state, setState] = useState({
        isReload: false,
        rowData: null,
        showInsp: false
    });

    const { portalSettings } = useContext(AppContext);
    const history = useHistory();

    const baseColumns = [
        { field: 'action', sortable: false, title: `Action`, width: 80, filterable: false },
        // { field: 'reg', sortable: false, title: `Vehicle Reg`, width: 120, filterable: true },
        { field: 'reg', sortable: true, title: `${portalSettings.portalSettingGridVehicleRegLabel || 'Vehicle Reg'}`, width: 120 },
        { field: 'dateInspected', sortable: false, title: `Inspection Date`, width: 150, filterable: true, renderer: formatters.DateTimeFormatter },
        { field: 'wipNumber', sortable: true, title: `${portalSettings.portalSettingGridWIPNoLabel || 'WIP No'}`, width: 80 },
        { field: 'customerName', sortable: true, title: `${portalSettings.portalSettingGridCustomerNameLabel || 'Customer Name'}` },
        { field: 'makeModel', sortable: true, title: `${portalSettings.portalSettingGridModelLabel || 'Model'}`, width: 200 },
        { field: 'signedOffDate', sortable: false, title: `Signed Off`, width: 130, filterable: true },
        { field: 'isoWeekNumber', sortable: false, title: `ISO Week`, width: 100, filterable: true }
    ];
    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => setState((st) => ({ ...st, rowData: record, isReload: false, showInsp: true }))}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const renderWipCol = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        padding: '0px 0px 0px 0px'
                        // fontWeight: 'bold',
                        // color: 'blue'
                    }}
                // onClick={() => history.push(`/Job/${record.vehicleInspectionHeaderRecordID}?ProcessId=1`)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleMoadlClose = () => {
        setState((st) => ({ ...st, rowData: null, isReload: true, showInsp: false }));
    };

    const column = useMemo(() => {
        let col = [...baseColumns];
        let colAction = col.find((m) => m.field === 'action');
        let colWip = col.find((m) => m.field === 'wipNumber');
        if (colAction) {
            colAction.renderer = editButton;
        }
        if (colWip) {
            colWip.renderer = renderWipCol;
        }

        return col;
    }, []);
    const url = `VehicleInspection/ByStatus?StatusID=${props.statusId || 0}`;
    return (
        <Grid container style={{ padding: 10 }}>
            <Grid item style={{ height: '100%', width: '100%' }}>
                <ReportGijgoGrid
                    dataConverter={(res) => ({
                        records: res.data.list,
                        total: res?.data?.total
                    })}
                    columns={column}
                    getUrl={url}
                    // isReload={state.isReload}
                    isShowTotal={false}
                />
            </Grid>
            {state.showInsp && <AddVehicleInspection onClose={handleMoadlClose} data={state.rowData} />}
            {/* {state.showInsp && <EditVehicleInspection onClose={handleMoadlClose} data={state.rowData} />} */}
        </Grid>
    );
};

export default VehicleInspectionGrid;
